module.exports = __webpack_public_path__ + "static/media/1_A1_14.dc3de61e.png";